import { Component } from '@angular/core';
import { FaqComponent } from 'app/shared/components/faq/faq.component';

@Component({
    selector: 'app-faq-electronics-b2c',
    templateUrl: './faq-electronics-b2c.component.html',
    styleUrls: ['./faq-electronics-b2c.component.scss'],
    imports: [FaqComponent],
})
export class FaqElectronicsB2CComponent {}
